// extracted by mini-css-extract-plugin
export default {"container":"Search_container__cqT1c","input":"Search_input__FkiVe","submitBtn":"Search_submitBtn__4uk8e"};